export enum IndirectTaxContentIngestionType {
  PRODUCT_TAXABILITY_CODES = 'product_taxability_codes',
  JURISDICTIONS = 'jurisdictions',
  JURISDICTION_PRODUCT_CLASSIFICATION = 'jurisdiction_product_classification',
  JURISDICTION_RATES = 'jurisdiction_rates',
  JURISDICTION_RULES = 'jurisdiction_rules',
  SOURCING_RULES = 'sourcing_rules',
  PRODUCT_RULES = 'product_rules',
  TAX_RATES = 'tax_rates',
  NEXUS_RULES = 'nexus_rules',
  FILING_CODE_MAPPINGS = 'filing_code_mappings',
  COUNTRY_ADDRESS_REQUIREMENTS = 'country_address_requirements',
  CONTENT_PORTALS = 'content_portals',
  CONTENT_TAX_TYPE_DETAILS = 'content_tax_type_details',
  TAX_REGISTRATION_CONTENT = 'tax_registration_content',
  CONTENT_FILING_CALENDAR = 'content_filing_calendar',
  FILING_CONTRIBUTIONS = 'filing_contributions',
  VAT_RATE_TIERS = 'vat_rate_tiers',
  VAT_PRODUCT_RULES = 'vat_product_rules',
}

/**
 * Named IndirectTaxContentIngestionJobStatus rather than JobStatus: both
 * `packages/api/job/types.ts` and `packages/api/new-sales-tax/job/types.ts` already
 * export different enums under that name, and both reach the root barrel.
 */
export enum IndirectTaxContentIngestionJobStatus {
  PENDING = 'PENDING',
  QUEUED = 'QUEUED',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export const INDIRECT_TAX_CONTENT_INGESTION_RUNNING_STATUSES: IndirectTaxContentIngestionJobStatus[] =
  [
    IndirectTaxContentIngestionJobStatus.PENDING,
    IndirectTaxContentIngestionJobStatus.QUEUED,
    IndirectTaxContentIngestionJobStatus.PROCESSING,
  ];

export interface IIndirectTaxContentIngestionJob {
  id: string;
  /** Null when the upstream job's content type is not one this client knows. */
  ingestionType: IndirectTaxContentIngestionType | null;
  status: IndirectTaxContentIngestionJobStatus;
  totalRows: number;
  processedRows: number;
  successCount: number;
  failureCount: number;
  submittedAt: string | null;
  startedAt: string | null;
  completedAt: string | null;
  failureReasons: string[];
}

export interface IIndirectTaxContentIngestionRefreshParams {
  ingestionType: IndirectTaxContentIngestionType;
}

export interface IIndirectTaxContentIngestionRefreshResponse {
  job: { id: string };
  message: string;
}

export interface IIndirectTaxContentIngestionJobResponse {
  job: IIndirectTaxContentIngestionJob;
}

export interface IIndirectTaxContentIngestionJobsResponse {
  jobs: IIndirectTaxContentIngestionJob[];
  total: number;
}
